/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Autofill_RetryInputs */

const en_directory_submit_autofill_retry = /** @type {(inputs: Directory_Submit_Autofill_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try again`)
};

const zh_directory_submit_autofill_retry = /** @type {(inputs: Directory_Submit_Autofill_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重试`)
};

/**
* | output |
* | --- |
* | "Try again" |
*
* @param {Directory_Submit_Autofill_RetryInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_autofill_retry = /** @type {((inputs?: Directory_Submit_Autofill_RetryInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Autofill_RetryInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_autofill_retry(inputs)
	return zh_directory_submit_autofill_retry(inputs)
});
export { directory_submit_autofill_retry as "directory.submit.autofill_retry" }